var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTestimonials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186,
    height: 166.951,
    viewBox: "0 0 186 166.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 1.151,
    y2: -0.194,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4eb757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4ec6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9332c5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_testimonials",
    transform: "translate(-8 -11.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "quote-2",
    d: "M114.308,178.945V145.425q15.894-.877,24.061-5.809t11.481-15.992q3.308-11.064,3.312-31.662H114.308V11.994H194V88.019q0,47.1-20.2,69.017t-59.494,21.91ZM8,178.945V145.425q15.894-.877,24.061-5.588t11.811-16q3.64-11.283,3.642-31.879H8V11.994H88.13V88.019q0,47.1-20.085,69.017T8,178.945Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTestimonials);
export default __webpack_public_path__ + "static/media/ic_testimonials.324b2beccb6d5ec93dd3925cda9dc87b.svg";
export { ForwardRef as ReactComponent };